import React from 'react';
import { Add, Close } from '@material-ui/icons';
import { Typography } from '@material-ui/core';
import clsx from 'clsx';
import { useStyles } from './styles';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';

export interface ComponentSelectorHeaderProps {
  onCloseClick: () => void;
  closed?: boolean;
}

// Header when no component selected yet
const ComponentsHeader: React.FC<ComponentSelectorHeaderProps> = (props) => {
  const classes = useStyles();
  const { onCloseClick, closed } = props;

  const handleClose = () => {
    onCloseClick();
  };

  return (
    <>
      <div className={clsx(classes.row, classes.header, classes.toggle)} onClick={handleClose}>
        <Typography>{t('chooseComponent')}</Typography>
        {closed ? <Add /> : <Close />}
      </div>
    </>
  );
};

export default ComponentsHeader;
